import { useId } from "react";
import type { ReactNode, SelectHTMLAttributes } from "react";

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  hint?: ReactNode;
  options?: SelectOption[];
  children?: ReactNode;
}

export function Select({
  label,
  hint,
  options,
  children,
  id,
  className,
  ...rest
}: SelectProps) {
  const generated = useId();
  const fieldId = id ?? generated;
  return (
    <div className="field">
      {label && (
        <label className="field__label" htmlFor={fieldId}>
          {label}
        </label>
      )}
      <select
        id={fieldId}
        className={["select", className ?? ""].filter(Boolean).join(" ")}
        {...rest}
      >
        {options
          ? options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))
          : children}
      </select>
      {hint && <span className="field__hint">{hint}</span>}
    </div>
  );
}
